import React, { useState, useEffect } from "react";
import "new_components/Insights/Insights.scss";
import Header from "new_components/Header/Header";
import Footer from "new_components/Footer/Footer";
import axios from "axios";
import apiUrls, { Image_Base_URL } from "new_components/BaseApi/BaseApi.js";
import ScrollToTopDefault from "components/Layouts/LayoutPrimary/ScrollToTopDefault";
import ProgressCircle from "new_components/ScrollProgress/ScrollProgress";
//import HomeBottomBanner from "new_components/Home/HomeBottomBanner";
import { useNavigate } from "react-router-dom";
import PreLoad from "new_components/PreLoad/PreLoad";
const Insights = () => {
  return (
    <>
      <ScrollToTopDefault />
      <ProgressCircle />
      <Header />
      <Body />
      <Footer />
    </>
  );
};

const Body = () => {
  return (
    <div>
      <InsightsBanner />
      <InsightCardsincludes />
      <InsightContactUs />
      {/* <HomeBottomBanner /> */}
    </div>
  );
};

const InsightsBanner = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const Preload = () => {
    return (
      <div className="preload preload-container">
        <div className="preload-logo">
          <div className="spinner" />
          <span className="icon icon-villa-fill" />
        </div>
      </div>
    );
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(apiUrls.insightsBanner);

        if (response.data?.status === "success" && response.data?.data) {
          setData(response.data.data[0]);
        } else {
          setError("No data available.");
        }
      } catch (err) {
        setError("Failed to load data. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div>
        <Preload />
      </div>
    );
  }

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  return (
    <section className="flat-section pb-0">
      <div className="container">
        <div
          className="row align-items-center justify-content-center wow fadeInUp insightsbanner mx-md-5 px-1 px-md-5"
          style={{
            backgroundImage: `url(${Image_Base_URL + data.image})`,
          }}
          data-wow-delay=".2s"
        >
          <div className="col-12 text-center">
            <h3 className="title text-white">{data.title}</h3>
          </div>
        </div>
      </div>
    </section>
  );
};

const InsightCardsincludes = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;

  const navigate = useNavigate();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(apiUrls.insightsBlog);
       // console.log("API Response:", response.data); // Debugging log
     if (response.data.status === "success") {
  setData(response.data.data || []);
} else {
  throw new Error("Failed to fetch data");
}
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);


 const totalPages = Math.ceil(data.length / itemsPerPage);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  
  const nextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const prevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };
  if (loading) {
  return <PreLoad />;
}
  if (error) return <div>Error: {error}</div>;
  if (!data) return <div>No data available</div>;

  return (
    <section className="flat-section">
      <div className="container">
        <div
          className="tf-grid-layout insight-cards-grid  wow fadeInUp mb-3"
          data-wow-delay=".2s"
        >
          {currentItems?.map((item,index) => {
           // console.log(`Item ${index} data:`, item);
           // console.log(`Item ${index} slug:`, item.created_at);
            return (
              <div className="box-service insight-custom-card text-start" key={item.slug || index}>
                    <div className="card-insights-logo-wrapper pb-2">
                                <img
                                   src={Image_Base_URL + (item.card_image || "no image available")}
                                   alt={item.card_title}
                                  className="card-insights-logo-wrapper"
                                />
                              </div>
                
                     <div className="card-content">
                       <div className="card-title">
                   {item.card_title}
                </div>
                <div className="card-author pb-2">{item.posted_by}</div>
                <button
                  onClick={() =>
                    navigate(`/insights/${item.slug}`)
                  }
                  className="tf-btn btn-line"
                >
                 {item.view_button_text}
                <span className="icon icon-arrow-right2" />
                </button>
              </div>
              </div>
            );
          })}
        </div>
            {/* ✅ Pagination Controls */}
        {totalPages > 1 && (
          <div className="pagination-controls text-center mt-4">
            <button
              className="btn"
              onClick={prevPage}
              disabled={currentPage === 1}
            >
              Previous
            </button>

            <span className="mx-3">
              Page {currentPage} of {totalPages}
            </span>

            <button
              className="btn"
              onClick={nextPage}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        )}
      </div>
    </section>
  );
};
const InsightContactUs = () => {
  const [calendlyData, setCalendlyData] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(apiUrls.insightCalendly);
        if (response.data.status === "success") {
          setCalendlyData(response.data.data); // Access the "data" array from the response
          setLoading(false);
        }
      } catch (err) {
        setError("Failed to fetch Contact data.");
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  return (
    <section className="row insightdualbannerlistingrow">
      <div className="col-12 col-md-8 insightdualbannerlistingone text-start p-3">
        <h6 className="title text-white text-start w-100 pb-2 fs-6">{calendlyData.text}
        </h6>
        <div className="text-white body-2 contact-links">
            {/* <a href={contactData.name} target="_blank"  rel="noopener noreferrer">
                  <h6 className="support-link pt-2">{contactData.cont_to_exp_heading1}</h6>
                </a> */}

                {/* <a href={contactData.cont_to_exp_url2} target="_blank"  rel="noopener noreferrer" className="support-link pt-2">
                  <h6 className="support-link"> {contactData.cont_to_exp_heading2}</h6>
                </a> */}

                 {calendlyData?.contacts?.map((contact, index) => (
            <a
              key={index}
              href={contact.calendly_url}
              target="_blank"
              rel="noopener noreferrer"
              className="support-link pt-2"
            >
              <h6 className="support-link">{contact.name}</h6>
            </a>
          ))}
        </div>
        
      </div>
      <div
        className="col-12 col-md-4 insightdualbannerlistingsecpic"
        style={{
          backgroundImage: `url(${Image_Base_URL}${calendlyData.image})`, 
        }}
      ></div>
    </section>
  );
};


export default Insights;
